import { Injectable } from '@angular/core';
import { SortDirection } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { CuttingMatBaseGroup, TypeGroupMaterial } from '../../models/cutting/cutting-material-group.model';
import { CuttingMaterial } from '../../models/cutting/cutting-material.model';

@Injectable()
export abstract class CuttingMatBaseDialogService {
  public abstract getGroups(groupType: TypeGroupMaterial[], forOrderPanel: boolean): Observable<CuttingMatBaseGroup[]>;
  public abstract getMaterials(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string,
    priceFrom: number,
    priceTo: number,
    priceSort: SortDirection,
    forOrderPanel: boolean
  ): Observable<{ totalCount: number; data: CuttingMaterial[] }>;
}
